export default function filterHandlerIfExistsInPostalOperator(
  handlerCodes,
  postalOperators,
) {
  const result = [];
  if (!postalOperators || postalOperators.length === 0) {
    return [...handlerCodes];
  }

  const addIfExists = (handlerCode) => {
    if (handlerCodes.includes(handlerCode)) {
      result.push(handlerCode);
    }
  };

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < postalOperators.length; index++) {
    const postalOperator = postalOperators[index];
    addIfExists(postalOperator.value);
  }

  return result;
}
